// Mobile Menu Toggle
(function () {
  var menuDrawer = document.getElementById('menu-drawer');
  var menuTriggers = document.querySelectorAll('.menu-burdger-btn,.close-menu');
  var lastFocus = null;

  function openMenu() {
    lastFocus = document.activeElement;
    document.body.classList.add('open-menu');
    if (menuDrawer) menuDrawer.setAttribute('aria-hidden', 'false');
    document.querySelectorAll('.menu-burdger-btn').forEach(function (b) { b.setAttribute('aria-expanded', 'true'); });
    setMenuDrawerHeight();
    if (menuDrawer) menuDrawer.focus();
  }

  function closeMenu() {
    document.body.classList.remove('open-menu');
    if (menuDrawer) menuDrawer.setAttribute('aria-hidden', 'true');
    document.querySelectorAll('.menu-burdger-btn').forEach(function (b) { b.setAttribute('aria-expanded', 'false'); });
    if (lastFocus && lastFocus.focus) lastFocus.focus();
  }

  menuTriggers.forEach(function (btn) {
    btn.addEventListener('click', function (e) {
      e.preventDefault();
      if (document.body.classList.contains('open-menu')) {
        closeMenu();
      } else {
        openMenu();
      }
    });
  });
})();

// Initialize Mobile Menu Content from Blocks
const initMobileMenu = () => {
  const tabsContainer = document.getElementById('mobile-tabs-container');
  const contentContainer = document.getElementById('mobile-content-container');
  
  if (tabsContainer && contentContainer) {
    document.querySelectorAll('.mobile-menu-source').forEach(source => {
      const btn = source.querySelector('.mobile-tab-btn');
      const content = source.querySelector('.mobile-menu-content');
      
      if (btn) tabsContainer.appendChild(btn);
      if (content) contentContainer.appendChild(content);
    });
    
    // Set first tab as active if none are active
    if (!tabsContainer.querySelector('.is-active')) {
      const firstBtn = tabsContainer.querySelector('.mobile-tab-btn');
      const firstContent = contentContainer.querySelector('.mobile-menu-content');
      if (firstBtn) firstBtn.classList.add('is-active');
      if (firstContent) firstContent.classList.add('is-active');
    }
  }
};

initMobileMenu();

// Mobile Tab Switching
const tabButtons = document.querySelectorAll('.mobile-tab-btn');
const menuContents = document.querySelectorAll('.mobile-menu-content');

tabButtons.forEach(btn => {
  btn.addEventListener('click', () => {
    const target = btn.getAttribute('data-tab-target');

    tabButtons.forEach(b => b.classList.remove('is-active'));
    menuContents.forEach(c => c.classList.remove('is-active'));

    btn.classList.add('is-active');

    const targetContent = document.getElementById(`mobile-menu-${target}`);
    if (targetContent) {
      targetContent.classList.add('is-active');
    }

    setMenuDrawerHeight();
  });
});

// Mobile Submenu Sliding

const submenuTriggers = document.querySelectorAll(
  '.mobile-column-link.has-submenu, .mobile-nav-link.has-submenu'
);

const backButtons = document.querySelectorAll('.submenu-back');

submenuTriggers.forEach(trigger => {
  trigger.addEventListener('click', e => {
    e.preventDefault();

    const submenu = document.getElementById(
      trigger.dataset.submenuId
    );

    if (submenu) {
      submenu.classList.add('is-open');

      requestAnimationFrame(() => {
        setMenuDrawerHeight();
      });
    }
  });
});

backButtons.forEach(btn => {
  btn.addEventListener('click', e => {
    e.preventDefault();

    const submenu = btn.closest('.mobile-submenu');
    submenu.classList.remove('is-open');

    requestAnimationFrame(() => {
      setMenuDrawerHeight();
    });
  });
});

// Desktop Mega Menu Toggle
const headerMenuBlocks = document.querySelectorAll('.header-menu-block');
let menuCloseTimeout = null;
let menuOpenTimeout = null;

const setMenuBlockExpanded = (block, expanded) => {
  const trigger = block.querySelector('.header-menu-link');
  if (trigger) trigger.setAttribute('aria-expanded', expanded ? 'true' : 'false');
};

// Shared by mouse, keyboard focus, and Escape handling below, so aria-expanded
// always stays in sync with the `is-open` class regardless of how it changed.
const activateMenuBlock = block => {
  document.body.classList.add('open-menu');
  if (document.body.classList.contains('open-search')) {
    document.body.classList.remove('open-search-drawer', 'open-search');
    if (document.getElementById('SearchDrawer')) document.getElementById('SearchDrawer').setAttribute('aria-hidden', 'true');
    document.querySelectorAll('.snippet-search-bar input[type="text"]').forEach(i => {
      i.value = '';
      i.blur();
    });
    const searchInput = document.getElementById('Search');
    if (searchInput) searchInput.blur();
  }

  headerMenuBlocks.forEach(otherBlock => {
    if (otherBlock !== block) {
      otherBlock.classList.remove('is-open');
      setMenuBlockExpanded(otherBlock, false);
      otherBlock.querySelectorAll('.mega-menu-item-v2').forEach(item => item.classList.remove('is-active'));
    }
  });

  block.classList.add('is-open');
  setMenuBlockExpanded(block, true);
};

const deactivateMenuBlock = block => {
  document.body.classList.remove('open-menu');
  document.body.classList.remove('menu-switching');
  block.classList.remove('is-open');
  setMenuBlockExpanded(block, false);
  block.querySelectorAll('.mega-menu-item-v2').forEach(item => item.classList.remove('is-active'));
};

headerMenuBlocks.forEach(block => {
  block.addEventListener('mouseenter', () => {
    if (window.innerWidth > 991) {
      if (menuCloseTimeout) {
        clearTimeout(menuCloseTimeout);
        menuCloseTimeout = null;
      }
      if (menuOpenTimeout) {
        clearTimeout(menuOpenTimeout);
        menuOpenTimeout = null;
      }

      const wasMenuOpen = document.body.classList.contains('open-menu');
      const isBlockOpen = block.classList.contains('is-open');

      // If the menu is already open, we delay switching by 150ms.
      // If the menu is closed, we also delay opening by 150ms to prevent accidental triggers.
      menuOpenTimeout = setTimeout(() => {
        const stillWasMenuOpen = document.body.classList.contains('open-menu');
        if (stillWasMenuOpen && !isBlockOpen) {
          document.body.classList.add('menu-switching');
        }

        activateMenuBlock(block);

        if (document.body.classList.contains('menu-switching')) {
          setTimeout(() => {
            document.body.classList.remove('menu-switching');
          }, 50);
        }
      }, 150);
    }
  });

  block.addEventListener('mouseleave', () => {
    if (window.innerWidth > 991) {
      if (menuOpenTimeout) {
        clearTimeout(menuOpenTimeout);
        menuOpenTimeout = null;
      }

      menuCloseTimeout = setTimeout(() => {
        deactivateMenuBlock(block);
      }, 100);
    }
  });

  // Keyboard support: tabbing onto the trigger (or anywhere inside the open
  // drawer) opens/keeps open instantly — no hover-intent delay, since that
  // delay exists only to ignore accidental mouse pass-overs.
  block.addEventListener('focusin', () => {
    if (window.innerWidth > 991) {
      if (menuCloseTimeout) {
        clearTimeout(menuCloseTimeout);
        menuCloseTimeout = null;
      }
      if (menuOpenTimeout) {
        clearTimeout(menuOpenTimeout);
        menuOpenTimeout = null;
      }
      activateMenuBlock(block);
    }
  });

  block.addEventListener('focusout', e => {
    if (window.innerWidth > 991) {
      // Don't close while focus is only moving between two elements inside
      // this same block (e.g. from the trigger link into the drawer).
      if (block.contains(e.relatedTarget)) return;
      deactivateMenuBlock(block);
    }
  });
});

// Escape closes whichever menu is open and returns focus to its trigger.
document.addEventListener('keydown', e => {
  if (e.key !== 'Escape') return;
  const openBlock = document.querySelector('.header-menu-block.is-open');
  if (!openBlock) return;
  deactivateMenuBlock(openBlock);
  const trigger = openBlock.querySelector('.header-menu-link');
  if (trigger) trigger.focus();
});

// Mega Menu Overlay & Empty Area Click
const headerOverlay = document.querySelector('.header-overlay');
const megaMenuDrawers = document.querySelectorAll('.mega-menu-drawer, .mega-menu-inner, .mega-menu-secondary-drawer, .mega-menu-secondary-inner');

[headerOverlay, ...megaMenuDrawers].forEach(element => {
  if (element) {
    element.addEventListener('click', (e) => {
      if (e.target === element) {
        if (menuCloseTimeout) {
          clearTimeout(menuCloseTimeout);
          menuCloseTimeout = null;
        }
        document.body.classList.remove('open-menu');
        document.body.classList.remove('menu-switching');
        document.querySelectorAll('.header-menu-block').forEach(block => {
          block.classList.remove('is-open');
          setMenuBlockExpanded(block, false);
        });
        document.querySelectorAll('.mega-menu-item-v2').forEach(item => item.classList.remove('is-active'));
      }
    });
  }
});

// Secondary Drawer Click Toggle
const secondaryTriggers = document.querySelectorAll('.mega-menu-item-v2.has-sub-items > a');
secondaryTriggers.forEach(trigger => {
  trigger.addEventListener('click', (e) => {
    if (window.innerWidth > 991) {
      e.preventDefault();
      const parent = trigger.parentElement;
      const isActive = parent.classList.contains('is-active');
      
      // Close all others in the same block/list
      parent.closest('.mega-menu-group-list')?.querySelectorAll('.mega-menu-item-v2').forEach(item => {
        item.classList.remove('is-active');
      });
      
      if (!isActive) {
        parent.classList.add('is-active');
      }
    }
  });
});


var lastScroll = 0;
const headerEl = document.querySelector('header');
const headerSection = document.querySelector('.main-header');

var headerScrollTicking = false;

function updateHeaderScrollState() {
  let scrollCount = window.pageYOffset;

  // Handle solid background for transparent header
  if (headerEl && headerEl.classList.contains('header-transparent')) {
    if (scrollCount > 50) {
      headerEl.classList.add('header-solid');
      headerSection.classList.add('header-fixed');
    } else {
      headerEl.classList.remove('header-solid');
      headerSection.classList.remove('header-fixed');
    }
  }

  if (scrollCount > lastScroll && scrollCount > 100) {
    document.body.classList.remove('scroll-up');
    document.body.classList.add('scroll-down');
  } else if (scrollCount < lastScroll) {
    document.body.classList.remove('scroll-down');
    document.body.classList.add('scroll-up');
  }

  if (scrollCount <= 0) {
    document.body.classList.remove('scroll-up', 'scroll-down');
  }

  lastScroll = scrollCount;
}

window.addEventListener('scroll', () => {
  if (!headerScrollTicking) {
    window.requestAnimationFrame(function () {
      updateHeaderScrollState();
      headerScrollTicking = false;
    });
    headerScrollTicking = true;
  }
}, { passive: true });

function setMenuDrawerHeight() {
  const drawer = document.querySelector('.snippet-menu-drawer');
  if (!drawer) return;

  const openSubmenu = drawer.querySelector('.mobile-submenu.is-open');
  const drawerTop = drawer.getBoundingClientRect().top;
  const maxDrawerHeight = window.innerHeight - drawerTop;

  if (openSubmenu) {
    const searchEl = drawer.querySelector('.mobile-search-wrapper');
    const tabsEl = drawer.querySelector('.mobile-tabs');
    const footerEl = drawer.querySelector('.mobile-drawer-footer');

    let topOffset = 100;
    if (searchEl && tabsEl) {
      topOffset = searchEl.offsetHeight + tabsEl.offsetHeight + 20;
    }
    const footerOffset = footerEl ? footerEl.offsetHeight : 42;
    const totalOffset = topOffset + footerOffset;

    openSubmenu.style.height = 'auto';
    const submenuContentHeight = openSubmenu.scrollHeight;
    openSubmenu.style.removeProperty('height');

    const targetHeight = submenuContentHeight + totalOffset;
    drawer.style.height = Math.min(targetHeight, maxDrawerHeight) + 'px';
  } else {
    drawer.style.height = 'auto';
    const inner = drawer.querySelector('.menu-drawer-inner');
    if (inner) {
      const height = inner.scrollHeight;
      drawer.style.height = Math.min(height, maxDrawerHeight) + 'px';
    }
  }
}

requestAnimationFrame(setMenuDrawerHeight);

window.addEventListener('resize', setMenuDrawerHeight);